<template>
    <ul v-if="pages.length > 1">
        <li
            v-if="!isFirstPage"
            class="ais-Pagination-item page-item ais-Pagination-item--previousPage"
        >
            <a
                :href="createURL(0)"
                @click.prevent="nextPage(refine, 0)"
                class="ais-Pagination-link page-link"
            >
                ‹‹
            </a>
        </li>
        <li v-if="!isFirstPage">
            <a
                class="ais-Pagination-link page-link"
                :href="createURL(currentRefinement - 1)"
                @click.prevent="nextPage(refine,currentRefinement - 1)"
            >
                ‹
            </a>
        </li>
        <li
            v-for="page in pages"
            :key="page"
            class="ais-Pagination-item page-item ais-Pagination-item--page"
            :class="{
                            'ais-Pagination-item--selected':
                                page === currentRefinement
                        }"
        >
            <a
                :href="createURL(page)"
                @click.prevent="nextPage(refine, page)"
                class="ais-Pagination-link page-link"
            >
                {{ page + 1 }}
            </a>
        </li>
        <li
            v-if="!isLastPage"
            class="ais-Pagination-item page-item ais-Pagination-item--nextPage"
        >
            <a
                :href="createURL(currentRefinement + 1)"
                @click.prevent="nextPage(refine,currentRefinement + 1)"
                class="ais-Pagination-link page-link"
            >
                ›
            </a>
        </li>
        <li
            v-if="!isLastPage"
            class="ais-Pagination-item page-item ais-Pagination-item--lastPage"
        >
            <a
                :href="createURL(nbPages)"
                @click.prevent="nextPage(refine, nbPages)"
                class="ais-Pagination-link page-link"
            >
                ››
            </a>
        </li>
    </ul>
</template>

<script>
export default {
    name: "Pagination",
    props: {
        nbPages: {
            type: Number,
            required: true,
        },
        currentRefinement: {
            type: Number,
            required: true
        },
        pages: {
          type: Array,
          required: true,
        },
        createURL: {
            type: Function,
            required: true
        },
        refine: {
            type: Function,
            required: true
        },
        isFirstPage: {
            type: Boolean,
            required: false
        },
        isLastPage: {
            type: Boolean,
            required: true
        }
    },
    methods: {
        nextPage(refine, page){

            refine(page)
            const AlgoliaResultsElement = document.getElementById('algolia_results')
            AlgoliaResultsElement.scrollIntoView({behavior: "smooth", block: "start"});
        }
    }
};
</script>